import classNames from 'classnames';
import React, { forwardRef, HTMLAttributes, ReactNode } from 'react';

import styles from './ShellBar.module.css';
import { Button } from '../Button';
import { Icon } from '../Icon';

export interface MainActionLinkProps extends Pick<
  HTMLAttributes<HTMLButtonElement | HTMLAnchorElement>,
  'style'
> {
  /**
   * The contents inside of the nav element.
   */
  children?: ReactNode;
  /**
   * The `href` of the anchor tag.
   */
  href?: string;
  /**
   * The name of the icon to be shown in the button.
   */
  icon?: string;
  /**
   * Optional id for e.g popover references
   */
  id?: string;
  /**
   * Defines if it's a button.
   */
  isButton?: boolean;
  /**
   * onClick event handler.
   */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * The `rel` of the anchor tag.
   */
  rel?: string;
  /**
   * The `target` of the anchor tag.
   */
  target?: string;
}

export const MainActionLink = forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  MainActionLinkProps
>(
  (
    {
      children,
      href,
      icon,
      id,
      isButton,
      onClick,
      rel = 'noreferrer noopener',
      style,
      target = '_blank',
    },
    ref,
  ) =>
    isButton ? (
      <Button
        className={styles['main-action-link']}
        design="Transparent"
        icon={icon}
        id={id}
        onClick={onClick}
        ref={ref as React.RefObject<HTMLButtonElement>}
        style={style}
      >
        {children}
      </Button>
    ) : (
      <a
        className={classNames({
          [styles['main-action-link']]: true,
          [`${'fd-button'}`]: true,
          [`${'fd-button--transparent'}`]: true,
        })}
        href={href as string}
        ref={ref as React.RefObject<HTMLAnchorElement>}
        rel={rel as string}
        style={style}
        target={target as string}
      >
        {icon && (
          <Icon
            className="sap-icon"
            name={icon}
          />
        )}
        {children && <span className="fd-button__text">{children}</span>}
      </a>
    ),
);
